import {configureStore} from "@reduxjs/toolkit";
import logger from 'redux-logger'
import rootReducer from './reducers';

const middlewares: any[] = [];

if (process.env.NODE_ENV !== 'production') {
    middlewares.push(logger);
}

const store = configureStore(
    {
        reducer: rootReducer ,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
    });

// @ts-ignore
if (import.meta.webpackHot) {
    // Enable Webpack hot module replacement for reducers
    // @ts-ignore
    import.meta.webpackHot.accept('./reducers', () => {
        store.replaceReducer(rootReducer);
    });
}

export type AppDispatch = typeof store.dispatch;

export default (): typeof store => store;
